import { useTranslation } from "react-i18next";
import type { BetRowData } from "./useBetHistory.js";
import { BetRow } from "./BetRow.js";
export function BetTable({ rows }: { rows: BetRowData[] }) {
  const { t } = useTranslation();
  return rows.length === 0 ? (
    <p className="text-sm text-muted">{t("bets.empty")}</p>
  ) : (
    <div className="overflow-x-auto">
      <table className="cx-bet-table">
        <thead className="text-muted">
          <tr>
            <th scope="col">{t("bets.player")}</th>
            <th scope="col">{t("bet.amount")}</th>
            <th scope="col">{t("bets.multiplier")}</th>
            <th scope="col">{t("bets.win")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((bet) => (
            <BetRow key={bet.betId} bet={bet} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
